/* cc-collection.js — Collection page CCS (4.3 + 4.3.1 + 4.3.2).
   Funciones:
     1. Load more AJAX.
     2. Quick add modal.
     3. Toast + bump cart.
     4. Drawer filtros: open/close + focus trap + scroll lock + swipe-right.
     5. AJAX filter apply (con sort como radio dentro del drawer).
     6. Sort radio: cambio aplica inmediato. Mobile cierra drawer.
     7. Reset-sort chip (✕ en chip de orden).
     8. Color swatches: mapping semántico de nombre → hex CSS, sin imágenes.
*/

/* ============================================================
   GA4 — eventos para Closecaption Store collections
   - view_item_list: al cargar el grid (cards iniciales)
   - select_item:    al click en card o botón quick-add
   - add_to_cart:    al confirmar talla en quick-add modal
   item_list_name = collection.handle (inyectado vía data-* en .cc-collection-page)
   ============================================================ */
(function ccGa4Init() {
  'use strict';
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];

  function getListContext() {
    var page = document.querySelector('[data-cc-grid]') || document.querySelector('.cc-collection-page');
    var listName = (page && page.getAttribute('data-collection-handle')) || (window.location.pathname || 'unknown');
    return { item_list_id: listName, item_list_name: listName };
  }

  function cardToItem(card, position) {
    return {
      item_id: card.getAttribute('data-product-id') || '',
      item_name: card.getAttribute('data-product-title') || '',
      item_brand: card.getAttribute('data-product-vendor') || '',
      price: parseFloat((parseInt(card.getAttribute('data-product-price'), 10) || 0) / 100).toFixed(2),
      currency: 'COP',
      index: position || (parseInt(card.getAttribute('data-product-index'), 10) || 0)
    };
  }

  // 1) view_item_list — al cargar el grid
  function pushViewItemList() {
    var cards = document.querySelectorAll('.cc-card[data-product-id]');
    if (!cards.length) return;
    var ctx = getListContext();
    var items = [];
    for (var i = 0; i < cards.length && i < 30; i++) {
      items.push(cardToItem(cards[i], i + 1));
    }
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: { item_list_id: ctx.item_list_id, item_list_name: ctx.item_list_name, items: items }
    });
  }

  // 2) select_item — delegación en click sobre cards
  function bindSelectItem() {
    document.addEventListener('click', function (e) {
      var target = e.target;
      var card = target.closest && target.closest('.cc-card[data-product-id]');
      if (!card) return;
      // Excluir botón add (eso dispara add_to_cart, no select)
      if (target.closest('[data-cc-add]')) return;
      var ctx = getListContext();
      window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_id: ctx.item_list_id,
          item_list_name: ctx.item_list_name,
          items: [cardToItem(card)]
        }
      });
    }, { passive: true, capture: true });
  }

  // 3) add_to_cart — hook al endpoint /cart/add.js (intercepta fetch original)
  function hookAddToCart() {
    var origFetch = window.fetch;
    if (!origFetch) return;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isCartAdd = url.indexOf('/cart/add') !== -1;
      var pr = origFetch.apply(this, arguments);
      if (!isCartAdd) return pr;
      pr.then(function (resp) {
        if (!resp || !resp.ok) return;
        try {
          var clone = resp.clone();
          clone.json().then(function (data) {
            var item = data && (data.items ? data.items[0] : data);
            if (!item) return;
            var ctx = getListContext();
            window.dataLayer.push({
              event: 'add_to_cart',
              ecommerce: {
                currency: 'COP',
                value: parseFloat((item.price || 0) / 100).toFixed(2),
                item_list_id: ctx.item_list_id,
                item_list_name: ctx.item_list_name,
                items: [{
                  item_id: String(item.product_id || item.id || ''),
                  item_name: item.product_title || item.title || '',
                  item_variant: item.variant_title || '',
                  item_brand: item.vendor || '',
                  price: parseFloat((item.price || 0) / 100).toFixed(2),
                  quantity: item.quantity || 1,
                  currency: 'COP'
                }]
              }
            });
          }).catch(function(){});
        } catch (e) {}
      }).catch(function () {});
      return pr;
    };
  }

  function init() {
    pushViewItemList();
    bindSelectItem();
    hookAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  'use strict';

  const pageWrap = document.querySelector('.cc-page-wrap[data-section-id]');
  const grid = document.querySelector('[data-cc-grid]');
  if (!grid) return;

  const sectionId = pageWrap ? pageWrap.dataset.sectionId : '';
  const drawer = document.getElementById('cc-drawer');
  const drawerForm = document.querySelector('[data-cc-filters-form]');
  const drawerCount = document.querySelector('[data-cc-drawer-count]');
  const activeChips = document.querySelector('[data-cc-active-chips]');
  const toolbar = document.querySelector('.cc-toolbar');
  const modal = document.getElementById('cc-qa-modal');
  const toast = document.getElementById('cc-toast');

  const isDesktop = () => window.matchMedia('(min-width:1024px)').matches;

  /* =====================================================
     COLOR SWATCHES — mapping nombre → hex / patrón
     ===================================================== */
  // Orden: claves más específicas ANTES de las más cortas (include match).
  const CC_COLOR_MAP = [
    ['rojooscuro', '#8B0000'],
    ['azulmarino', '#0A1F44'],
    ['azulcielo', '#4A90D9'],
    ['azulroyal', '#002D72'],
    ['azulclaro', '#6AA9E9'],
    ['azuloscuro', '#0A1F44'],
    ['verdeoscuro', '#0B3D0B'],
    ['verdemilitar', '#4B5320'],
    ['verdeclaro', '#7DCB7D'],
    ['grisoscuro', '#4A4A4A'],
    ['grisclaro', '#BEBEBE'],
    ['rosaoscuro', '#C2185B'],
    ['rosaclaro', '#F8BBD0'],
    ['multicolor', '__MULTI__'],
    ['estampado', '__PATTERN__'],
    ['camuflaje', '__PATTERN__'],
    ['camo', '__PATTERN__'],
    ['negro', '#000000'],
    ['black', '#000000'],
    ['blanco', '#FFFFFF'],
    ['white', '#FFFFFF'],
    ['gris', '#808080'],
    ['grey', '#808080'],
    ['gray', '#808080'],
    ['rojo', '#E63946'],
    ['red', '#E63946'],
    ['vinotinto', '#722F37'],
    ['vino', '#722F37'],
    ['azul', '#1E4A8F'],
    ['blue', '#1E4A8F'],
    ['verde', '#2D7D46'],
    ['green', '#2D7D46'],
    ['amarillo', '#F9C74F'],
    ['yellow', '#F9C74F'],
    ['naranja', '#F3722C'],
    ['orange', '#F3722C'],
    ['cafe', '#6B4423'],
    ['marron', '#6B4423'],
    ['brown', '#6B4423'],
    ['beige', '#E8D5B7'],
    ['crema', '#F5E6C8'],
    ['rosado', '#F48FB1'],
    ['rosa', '#F48FB1'],
    ['pink', '#F48FB1'],
    ['morado', '#6A4C93'],
    ['violeta', '#6A4C93'],
    ['purpura', '#6A4C93'],
    ['purple', '#6A4C93'],
    ['lila', '#B39DDB'],
    ['dorado', '#D4AF37'],
    ['oro', '#D4AF37'],
    ['gold', '#D4AF37'],
    ['plateado', '#C0C0C0'],
    ['plata', '#C0C0C0'],
    ['silver', '#C0C0C0'],
    ['turquesa', '#40E0D0'],
    ['celeste', '#87CEEB'],
    ['coral', '#FF7F50'],
    ['fucsia', '#E91E63'],
    ['salmon', '#FA8072'],
  ];

  function normalizeColor(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // strip tildes
      .replace(/ñ/g, 'n')
      .replace(/[^a-z0-9]/g, '');
  }

  function getSwatchColor(colorName) {
    const n = normalizeColor(colorName);
    if (!n) return null;
    for (const [key, hex] of CC_COLOR_MAP) {
      if (n.includes(key)) return hex;
    }
    return null;
  }

  function applySwatchColors(root) {
    (root || document).querySelectorAll('.cc-swatch__dot[data-color-label]').forEach((dot) => {
      const label = dot.dataset.colorLabel || '';
      const val = getSwatchColor(label);
      // Reset clases previas
      dot.classList.remove('cc-swatch__dot--multi', 'cc-swatch__dot--pattern', 'cc-swatch__dot--fallback');
      dot.style.background = '';
      if (!val) {
        dot.classList.add('cc-swatch__dot--fallback');
        dot.title = label + ' (color sin mapear)';
      } else if (val === '__MULTI__') {
        dot.classList.add('cc-swatch__dot--multi');
      } else if (val === '__PATTERN__') {
        dot.classList.add('cc-swatch__dot--pattern');
      } else {
        dot.style.background = val;
      }
    });
  }
  applySwatchColors();

  /* =====================================================
     HEADER OFFSET — medición dinámica (4.3.5)
     Expone --cc-header-offset para que el drawer arranque
     debajo del header sticky del sitio.
     ===================================================== */
  function updateHeaderOffset() {
    const header = document.querySelector('.section-header');
    let offset = 100;
    if (header) {
      const rect = header.getBoundingClientRect();
      offset = Math.max(0, rect.bottom);
    }
    document.documentElement.style.setProperty('--cc-header-offset', offset + 'px');
  }
  updateHeaderOffset();
  window.addEventListener('resize', updateHeaderOffset);
  let headerScrollTick = null;
  window.addEventListener('scroll', () => {
    if (headerScrollTick) return;
    headerScrollTick = setTimeout(() => {
      updateHeaderOffset();
      headerScrollTick = null;
    }, 100);
  }, { passive: true });

  /* =====================================================
     DRAWER OPEN/CLOSE (mobile) — 6 rutas de escape (4.3.4)
     ===================================================== */
  let lastFocus = null;
  let emergencyTimer = null;
  let emergencyBtn = null;

  function isOpen() {
    return drawer && drawer.getAttribute('aria-hidden') === 'false';
  }

  function ensureEmergencyBtn() {
    if (emergencyBtn) return emergencyBtn;
    emergencyBtn = document.createElement('button');
    emergencyBtn.type = 'button';
    emergencyBtn.className = 'cc-drawer-emergency';
    emergencyBtn.textContent = '✕ Cerrar filtros';
    emergencyBtn.addEventListener('click', () => closeDrawer());
    document.body.appendChild(emergencyBtn);
    return emergencyBtn;
  }

  function armEmergencyTimer() {
    clearTimeout(emergencyTimer);
    emergencyTimer = setTimeout(() => {
      if (!isOpen() || isDesktop()) return;
      ensureEmergencyBtn().classList.add('cc-drawer-emergency--show');
    }, 60000);
  }

  function disarmEmergencyTimer() {
    clearTimeout(emergencyTimer);
    if (emergencyBtn) emergencyBtn.classList.remove('cc-drawer-emergency--show');
  }

  function openDrawer() {
    if (!drawer || isDesktop()) return;
    if (isOpen()) return;
    lastFocus = document.activeElement;
    updateHeaderOffset(); // recalcula por si el usuario venía scrolleado
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cc-drawer-open');
    const closeBtn = drawer.querySelector('.cc-drawer__close');
    if (closeBtn) closeBtn.focus();
    armEmergencyTimer();
  }

  function closeDrawer() {
    if (!drawer) return;
    if (isDesktop()) return;
    if (!isOpen()) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cc-drawer-open');
    disarmEmergencyTimer();
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
    }
  }

  // Escape route 1 — botón trigger abre drawer (botón original + flotante)
  document.querySelectorAll('[data-cc-drawer-open]').forEach((el) =>
    el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); })
  );

  if (drawer) {
    // Escape route 2 — botón ✕ + tap overlay
    drawer.querySelectorAll('[data-cc-drawer-close]').forEach((el) =>
      el.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); closeDrawer(); })
    );

    // Escape route 3 — ESC key (mobile + desktop, aunque en desktop el drawer está fijo)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen() && !isDesktop()) closeDrawer();
    });

    // Focus trap mobile
    drawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !isOpen() || isDesktop()) return;
      const focusables = drawer.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Escape route 4 — swipe-right >60px
    let touchStartX = null;
    let touchStartY = null;
    drawer.addEventListener('touchstart', (e) => {
      if (isDesktop()) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      armEmergencyTimer(); // reset timer on interaction
    }, { passive: true });
    drawer.addEventListener('touchend', (e) => {
      if (touchStartX === null || isDesktop()) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (dx > 60 && dy < 50) closeDrawer();
      touchStartX = touchStartY = null;
    }, { passive: true });

    // Reset emergency timer on any interaction inside drawer
    drawer.addEventListener('click', armEmergencyTimer);
    drawer.addEventListener('scroll', armEmergencyTimer, true);
  }

  // Escape route 5 — click en links del header (navegar fuera) cierra drawer
  document.addEventListener('click', (e) => {
    if (!isOpen() || isDesktop()) return;
    const link = e.target.closest('a[href]');
    if (!link) return;
    // No interceptar links DENTRO del drawer (chips, etc.)
    if (drawer && drawer.contains(link)) return;
    closeDrawer();
  });

  window.addEventListener('resize', () => {
    if (isDesktop() && drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.remove('cc-drawer-open');
      document.body.style.top = '';
      disarmEmergencyTimer();
    } else if (drawer && isOpen()) {
      // Stayed mobile, drawer open — keep
    }
  });

  if (isDesktop() && drawer) {
    drawer.setAttribute('aria-hidden', 'false');
  }

  /* =====================================================
     FLOATING FILTER BUTTON (mobile)
     ===================================================== */
  const floatingBtn = document.getElementById('cc-floating-filter');
  if (floatingBtn) {
    const threshold = parseInt(floatingBtn.dataset.ccFloatingThreshold || '400', 10);
    floatingBtn.removeAttribute('hidden');

    function isNearFooter() {
      const buffer = 300;
      return (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - buffer);
    }
    function drawerIsOpen() {
      return drawer && drawer.getAttribute('aria-hidden') === 'false' && !isDesktop();
    }
    function updateFloatingVisibility() {
      if (isDesktop()) { floatingBtn.classList.remove('cc-floating-filter--show'); return; }
      if (drawerIsOpen()) { floatingBtn.classList.remove('cc-floating-filter--show'); return; }
      if (isNearFooter()) { floatingBtn.classList.remove('cc-floating-filter--show'); return; }
      if (window.scrollY > threshold) floatingBtn.classList.add('cc-floating-filter--show');
      else floatingBtn.classList.remove('cc-floating-filter--show');
    }

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => { updateFloatingVisibility(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updateFloatingVisibility);
    updateFloatingVisibility();

    // Observar cambios de aria-hidden en drawer → actualizar botón flotante
    if (drawer) {
      const mo = new MutationObserver(updateFloatingVisibility);
      mo.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    // Actualizar contador del badge cuando cambia filter count
    function syncFloatingCount() {
      const countEl = floatingBtn.querySelector('[data-cc-floating-count]');
      if (!countEl) return;
      const toolbarCount = document.querySelector('.cc-toolbar__filters-count');
      let n = 0;
      if (toolbarCount) {
        const m = toolbarCount.textContent.match(/\d+/);
        if (m) n = parseInt(m[0], 10);
      }
      countEl.textContent = n > 0 ? n : '';
      if (n > 0) countEl.removeAttribute('hidden'); else countEl.setAttribute('hidden', '');
    }
    syncFloatingCount();
    // expose for AJAX reload to call
    window.__ccSyncFloatingCount = syncFloatingCount;
  }

  /* =====================================================
     TALLA + DISPONIBILIDAD (13-sep [3c])
     Al elegir talla se agrega filter.v.availability=1: combinado con la talla, Shopify filtra a
     nivel de VARIANTE → solo gorras con ESA talla disponible (antes: 7 5/8 mostraba 104, 57 agotadas).
     La disponibilidad es implícita: sin chip, sin contar, y se va cuando se quita la talla.
     ===================================================== */
  const AVAIL_PARAM = 'filter.v.availability';

  function sizeParamName() {
    const el = document.querySelector('[data-cc-filter-kind="size"]');
    return (el && el.dataset.ccFilterParam) || 'filter.v.option.talla';
  }

  function hasSize(params) {
    return params.getAll(sizeParamName()).length > 0;
  }

  function coupleAvailability(params) {
    if (hasSize(params)) {
      params.delete(AVAIL_PARAM);
      params.set(AVAIL_PARAM, '1');
    }
    return params;
  }

  // Quitar una talla: si no queda ninguna, la disponibilidad implícita se va con ella.
  function uncoupleIfNoSize(href) {
    try {
      const u = new URL(href, window.location.origin);
      if (!hasSize(u.searchParams)) u.searchParams.delete(AVAIL_PARAM);
      const q = u.searchParams.toString();
      return q ? `${u.pathname}?${q}` : u.pathname;
    } catch (e) {
      return href;
    }
  }

  // Conteos de talla coherentes: sin talla elegida, Shopify cuenta gorras que TIENEN la talla (aunque
  // esté agotada). Al abrir el acordeón se piden los conteos con disponibilidad=1, que son los que se
  // obtienen al hacer clic.
  const sizeCountsCache = {};
  async function fixSizeCounts(details) {
    const params = new URLSearchParams(window.location.search);
    if (hasSize(params) || params.get(AVAIL_PARAM) === '1') return; // ya vienen a nivel de variante
    params.delete(AVAIL_PARAM);
    params.set(AVAIL_PARAM, '1');
    params.delete('page');
    const url = `${window.location.pathname}?${params.toString()}&section_id=${sectionId}`;
    try {
      let html = sizeCountsCache[url];
      if (!html) {
        const r = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
        if (!r.ok) return;
        html = await r.text();
        sizeCountsCache[url] = html;
      }
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const src = tmp.querySelector('[data-cc-filter-kind="size"]');
      if (!src) return;
      const counts = {};
      src.querySelectorAll('input.cc-filter__cb').forEach((cb) => {
        const c = cb.closest('label') && cb.closest('label').querySelector('[data-cc-opt-count]');
        if (c) counts[cb.value] = c.textContent;
      });
      details.querySelectorAll('input.cc-filter__cb').forEach((cb) => {
        const lab = cb.closest('label');
        const c = lab && lab.querySelector('[data-cc-opt-count]');
        if (!c) return;
        const txt = counts[cb.value] !== undefined ? counts[cb.value] : '(0)';
        c.textContent = txt;
        const off = (parseInt(txt.replace(/\D/g, ''), 10) || 0) === 0 && !cb.checked;
        cb.disabled = off;
        lab.classList.toggle('is-disabled', off);
      });
      details.dataset.ccCountsFixed = '1';
    } catch (e) {
      console.error('cc-collection size counts error', e);
    }
  }

  /* =====================================================
     AJAX FILTER + SORT
     ===================================================== */
  function buildFilterURL(overrides) {
    const params = new URLSearchParams();
    if (drawerForm) {
      drawerForm.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => {
        if (cb.name) params.append(cb.name, cb.value);
      });
      drawerForm.querySelectorAll('input[type="number"]').forEach((n) => {
        if (!n.name || n.value === '' || n.value === n.placeholder) return;
        // 13-sep [3c]: el rango por defecto (0 – tope del catálogo) no es un filtro. Antes el máximo
        // («149900») nunca igualaba al placeholder («149.900») y se colaba en TODO filtrado: chip
        // «Precio» que nadie eligió y una gorra menos (249 de 250).
        if (/\.lte$/.test(n.name) && n.max !== '' && Number(n.value) >= Number(n.max)) return;
        if (/\.gte$/.test(n.name) && Number(n.value) <= 0) return;
        params.append(n.name, n.value);
      });
      const sortRadio = drawerForm.querySelector('input[name="cc-sort"]:checked');
      if (sortRadio && sortRadio.value) {
        params.set('sort_by', sortRadio.value);
      }
    }
    if (overrides) {
      if (overrides.resetSort) params.delete('sort_by');
      if (overrides.sortBy) params.set('sort_by', overrides.sortBy);
    }
    coupleAvailability(params);
    const query = params.toString();
    const base = window.location.pathname || '/';
    return query ? `${base}?${query}` : base;
  }

  async function reloadGrid(newUrl) {
    if (!grid) return;
    grid.classList.add('cc-grid--loading');
    try {
      const fetchUrl = newUrl + (newUrl.includes('?') ? '&' : '?') + 'section_id=' + sectionId;
      const r = await fetch(fetchUrl, { headers: { 'X-Requested-With': 'fetch' } });
      if (!r.ok) throw new Error('fetch failed ' + r.status);
      const html = await r.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      const newGrid = tmp.querySelector('[data-cc-grid]');
      if (newGrid) grid.innerHTML = newGrid.innerHTML;

      const newChips = tmp.querySelector('[data-cc-active-chips]');
      const currentChipsWrap = document.querySelector('[data-cc-active-chips]');
      if (newChips && currentChipsWrap) {
        currentChipsWrap.innerHTML = newChips.innerHTML;
        if (newChips.hasAttribute('hidden')) currentChipsWrap.setAttribute('hidden', '');
        else currentChipsWrap.removeAttribute('hidden');
      }

      const newDrawerBody = tmp.querySelector('[data-cc-filters-form]');
      if (newDrawerBody && drawerForm) {
        drawerForm.innerHTML = newDrawerBody.innerHTML;
        rebindDrawerListeners();
        applySwatchColors(drawerForm);
      }

      const newDrawerCount = tmp.querySelector('[data-cc-drawer-count]');
      if (newDrawerCount && drawerCount) drawerCount.textContent = newDrawerCount.textContent;

      const newToolbarCount = tmp.querySelector('.cc-toolbar__filters-count');
      const currentToolbarBtn = document.querySelector('.cc-toolbar__filters-btn');
      const currentToolbarCount = document.querySelector('.cc-toolbar__filters-count');
      if (newToolbarCount && currentToolbarCount) {
        currentToolbarCount.textContent = newToolbarCount.textContent;
      } else if (newToolbarCount && currentToolbarBtn && !currentToolbarCount) {
        currentToolbarBtn.insertAdjacentHTML('beforeend',
          '<span class="cc-toolbar__filters-count">' + newToolbarCount.textContent + '</span>');
      } else if (!newToolbarCount && currentToolbarCount) {
        currentToolbarCount.remove();
      }

      const newHeaderCount = tmp.querySelector('.cc-collection-header__count');
      const currentHeaderCount = document.querySelector('.cc-collection-header__count');
      if (newHeaderCount && currentHeaderCount) {
        currentHeaderCount.textContent = newHeaderCount.textContent;
      }

      // VER MÁS vive fuera de [data-cc-grid]: sin esto seguía diciendo «de 249» con el filtro puesto.
      const newLoadMore = tmp.querySelector('[data-cc-loadmore-wrap]');
      const currentLoadMore = document.querySelector('[data-cc-loadmore-wrap]');
      if (newLoadMore && currentLoadMore) {
        currentLoadMore.innerHTML = newLoadMore.innerHTML;
      }

      window.history.replaceState({}, '', newUrl);
      updateLoadMoreCount();
      bindChipHandlers();
      if (typeof window.__ccSyncFloatingCount === 'function') window.__ccSyncFloatingCount();
    } catch (e) {
      console.error('cc-collection reload error', e);
    }
    grid.classList.remove('cc-grid--loading');
    document.documentElement.classList.remove('cc-coupling'); // ver script inline de cc-collection-grid
  }

  let applyTimer = null;
  function debounceApply(delay) {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(() => reloadGrid(buildFilterURL()), delay || 350);
  }

  function rebindDrawerListeners() {
    if (!drawerForm) return;

    drawerForm.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
      cb.addEventListener('change', () => {
        if (isDesktop()) reloadGrid(buildFilterURL());
      });
    });

    drawerForm.querySelectorAll('input[type="number"]').forEach((n) => {
      n.addEventListener('change', () => {
        if (isDesktop()) debounceApply(500);
      });
    });

    drawerForm.querySelectorAll('[data-cc-sort-radio]').forEach((r) => {
      r.addEventListener('change', async () => {
        if (!r.checked) return;
        await reloadGrid(buildFilterURL());
        if (!isDesktop()) closeDrawer();
      });
    });

    drawerForm.querySelectorAll('details[data-cc-filter-kind="size"]').forEach((d) => {
      d.addEventListener('toggle', () => {
        if (d.open && !d.dataset.ccCountsFixed) fixSizeCounts(d);
      });
      if (d.open) fixSizeCounts(d);
    });
  }
  rebindDrawerListeners();

  const applyBtn = document.querySelector('[data-cc-drawer-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      applyBtn.disabled = true;
      await reloadGrid(buildFilterURL());
      applyBtn.disabled = false;
      closeDrawer();
    });
  }

  const clearBtn = document.querySelector('[data-cc-drawer-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', (e) => {
      e.preventDefault();
      reloadGrid(window.location.pathname);
    });
  }

  if (drawerForm) {
    drawerForm.addEventListener('submit', (e) => {
      e.preventDefault();
      reloadGrid(buildFilterURL());
    });
  }

  /* =====================================================
     CHIP HANDLERS (reset-sort + filter chips remove)
     ===================================================== */
  function bindChipHandlers() {
    const resetSortBtns = document.querySelectorAll('[data-cc-reset-sort]');
    resetSortBtns.forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        reloadGrid(buildFilterURL({ resetSort: true }));
      });
    });
    // Filter remove chips navegan al url_to_remove nativo — no se interceptan.
    // Pero en desktop el reload completo rompe el estado: usamos AJAX.
    document.querySelectorAll('[data-cc-remove-filter]').forEach((chip) => {
      if (chip.dataset.bound) return;
      chip.dataset.bound = '1';
      chip.addEventListener('click', (e) => {
        e.preventDefault();
        let href = chip.getAttribute('href');
        if (href && chip.hasAttribute('data-cc-size-chip')) href = uncoupleIfNoSize(href);
        if (href) reloadGrid(href);
      });
    });
  }
  bindChipHandlers();

  /* =====================================================
     LOAD MORE — 13-sep [3c]: el estado vive en el botón (data-total / data-current-page) y el
     contenedor [data-cc-loadmore-wrap] se reemplaza en cada filtrado → contador y páginas siguen
     al total FILTRADO. Delegado: sobrevive al reemplazo.
     ===================================================== */
  function updateLoadMoreCount() {
    const btn = document.querySelector('[data-cc-loadmore-btn]');
    if (!btn) return;
    const box = btn.closest('.cc-loadmore') || document;
    const countEl = box.querySelector('[data-cc-loadmore-count]');
    const doneEl = box.querySelector('[data-cc-loadmore-done]');
    const total = parseInt(btn.dataset.total || '0', 10);
    const visible = Math.min(grid.querySelectorAll('.cc-card').length, total);
    const tpl = btn.dataset.countTemplate || 'Mostrando _VISIBLE_ de _TOTAL_ gorras';
    if (countEl) countEl.textContent = tpl.replace('_VISIBLE_', visible).replace('_TOTAL_', total);
    if (visible >= total) {
      btn.style.display = 'none';
      if (doneEl) doneEl.style.display = 'block';
    }
  }
  updateLoadMoreCount();

  document.addEventListener('click', async function (ev) {
    const btn = ev.target.closest('[data-cc-loadmore-btn]');
    if (!btn) return;
    ev.preventDefault();
    if (btn.disabled) return;
    const nextPage = parseInt(btn.dataset.currentPage || btn.dataset.startPage || '1', 10) + 1;
    btn.disabled = true;
    btn.textContent = 'CARGANDO…';
    try {
      const search = window.location.search || '';
      const sep = search ? '&' : '?';
      const url = `${window.location.pathname}${search}${sep}page=${nextPage}&section_id=${sectionId}`;
      const r = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
      if (!r.ok) throw new Error('fetch failed ' + r.status);
      const html = await r.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newCards = tmp.querySelectorAll('[data-cc-grid] .cc-card');
      newCards.forEach((c) => grid.appendChild(c));
      btn.dataset.currentPage = String(nextPage);
    } catch (e) {
      console.error('cc-collection load more error', e);
    }
    btn.disabled = false;
    btn.textContent = btn.dataset.label || 'VER MÁS GORRAS';
    updateLoadMoreCount();
  });

  // URL directa con talla y sin disponibilidad (links compartidos, anuncios, bot): se completa una vez.
  (function coupleOnLoad() {
    const params = new URLSearchParams(window.location.search);
    if (!hasSize(params) || params.get(AVAIL_PARAM) === '1') {
      document.documentElement.classList.remove('cc-coupling');
      return;
    }
    coupleAvailability(params);
    params.delete('page');
    reloadGrid(`${window.location.pathname}?${params.toString()}`);
  })();

  /* =====================================================
     QUICK ADD + CART (sin cambios)
     ===================================================== */
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('cc-toast--show');
    setTimeout(() => toast.classList.remove('cc-toast--show'), 2200);
  }

  function bumpCartIcon() {
    const icon = document.querySelector('.header__icon--cart, [aria-label*="carrito" i], [aria-label*="cart" i]');
    if (!icon) return;
    icon.style.transition = 'transform .2s ease';
    icon.style.transform = 'scale(1.25)';
    setTimeout(() => { icon.style.transform = ''; }, 250);
  }

  async function addToCart(variantId, qty) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 }),
    });
    if (!r.ok) throw new Error('add failed');
    return await r.json();
  }

  function openModal() { modal && modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeModal() { modal && modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  if (modal) {
    modal.querySelectorAll('[data-cc-qa-close]').forEach((el) => el.addEventListener('click', closeModal));
  }

  async function fetchProductData(handle) {
    const r = await fetch(`/products/${handle}.js`);
    if (!r.ok) throw new Error('product fetch failed');
    return await r.json();
  }

  async function openQuickAdd(card) {
    if (!modal) return;
    const handle = card.dataset.productHandle;
    try {
      const product = await fetchProductData(handle);
      modal.querySelector('.cc-qa-img').src = product.featured_image || '';
      modal.querySelector('.cc-qa-img').alt = product.title;
      modal.querySelector('.cc-qa-title').textContent = product.title;
      const priceEl = modal.querySelector('.cc-qa-price');
      priceEl.textContent = '$' + (product.price / 100).toLocaleString('es-CO');
      const sizesEl = modal.querySelector('.cc-qa-sizes');
      sizesEl.innerHTML = '';
      let selectedVariantId = null;
      const submitBtn = modal.querySelector('[data-cc-qa-submit]');
      submitBtn.disabled = true;
      product.variants.forEach((v) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cc-qa-size';
        btn.textContent = v.options[0] || v.title;
        btn.setAttribute('aria-pressed', 'false');
        if (!v.available) btn.disabled = true;
        btn.addEventListener('click', () => {
          sizesEl.querySelectorAll('.cc-qa-size').forEach((b) => b.setAttribute('aria-pressed', 'false'));
          btn.setAttribute('aria-pressed', 'true');
          selectedVariantId = v.id;
          submitBtn.disabled = false;
        });
        sizesEl.appendChild(btn);
      });
      submitBtn.onclick = async function () {
        if (!selectedVariantId) return;
        submitBtn.disabled = true;
        submitBtn.textContent = 'AGREGANDO…';
        try {
          await addToCart(selectedVariantId, 1);
          closeModal();
          bumpCartIcon();
          showToast('✓ Añadido al carrito');
        } catch (err) {
          submitBtn.disabled = false;
          showToast('Error al agregar. Intenta de nuevo.');
        }
        submitBtn.textContent = 'Agregar al carrito';
      };
      openModal();
    } catch (e) {
      console.error(e);
      showToast('No se pudo cargar el producto');
    }
  }

  document.addEventListener('click', async function (ev) {
    const btn = ev.target.closest('[data-cc-add]');
    if (!btn) return;
    ev.preventDefault();
    const card = btn.closest('.cc-card');
    if (!card) return;
    const variantCount = parseInt(card.dataset.variantCount || '1', 10);
    if (variantCount === 1) {
      const variantId = btn.dataset.variantId;
      btn.disabled = true;
      btn.textContent = 'AGREGANDO…';
      try {
        await addToCart(variantId, 1);
        bumpCartIcon();
        showToast('✓ Añadido al carrito');
        btn.textContent = '✓ AGREGADO';
        setTimeout(() => { btn.disabled = false; btn.textContent = '+ Agregar'; }, 1500);
      } catch (e) {
        btn.disabled = false;
        btn.textContent = '+ Agregar';
        showToast('Error al agregar');
      }
    } else {
      openQuickAdd(card);
    }
  });
})();
